import { getResource as _getResource } from '@jorgenevens/rest-store/vuex';
export { apply, getPage, getRange } from '@jorgenevens/rest-store/vuex';

export
function getResource(selector, options) {
  if (!options.placeholder)
    options.placeholder = {};

  return _getResource(selector, options);
}